export class ValidationServiceLabelHN {

    validation: {
        required: string;
        confirmEmailValidation: string;
        confirmPANValidation: string;
        confirmTINValidation: string;
        tinValidation: string;
        salaryValidation: string;
        confirmMobileValidation: string;
        nameValidation: string;
        midNameValidation: string;
        dateValidation: string;
        toDateValidation: string;
        aadharValidation: string;
        itrIncomeValidation: string;
        downpaymentMaxValidation: string;
        downpaymentMinValidation: string;
        tenDigitPhoneValidation: string;
        thirtyCharExceedNameValidation: string;
        sixtyCharExceedNameValidation: string;
        twentyCharExceedLastNameValidation: string;
        tweleveDigitAdharValidation: string;
        fortyCharExceedAddressValidation: string;
        fiftyCharExceedAreaValidation: string;
        twentyFiveCharExceedCityValidation: string;
        sixDigitPinCodeValidation: string;
        tenDigitPANValidation: string;
        fifteenDigitNumericWithTwoDecimalValidation: string;
        notInRangeFinProduct: string;
        maxCharExceedValidation: string;
        maxValueExceedValidation: string;
        minIncome26000: string;
        minIncome312000: string;
        minValueValidation: string;
        validPhoneValidation: string;
        validNameValidation: string;
        validNumericAdharValidation: string;
        validEmailValidation: string;
        validPANValidation: string;
        validDesignationValidation: string;
        validPincodeValidation: string;
        validAmountValidation: string;
        numericValidation: string;
        noSpecialCharValidation: string;
        validVariantValidation: string;
        patternMismatchValidation: string;
        tenDigitValidPhoneValidation: string;
        min6CharValidation: string;
        tewelveDigitAdharValidation: string;
        min2CharValidation: string;
        min4CharValidation: string;
        min10CharValidation: string;
        minCharValidation: string;
        
    }

   

    constructor() {

        this.validation = {
            required: "यह फ़ील्ड आवश्यक है।",
            confirmEmailValidation: 'प्राथमिक और द्वितीयक ईमेल पते समान नहीं हो सकते हैं',
            confirmPANValidation: 'पुष्टि करें कि पैन और पैन फ़ील्ड के अलग-अलग मान हैं।',
            confirmTINValidation: 'पुष्टि करें कि टिन नंबर और टिन नंबर के अलग-अलग मान हैं।',
            tinValidation: 'एक मान्य टिन नंबर दर्ज करें',
            salaryValidation: 'शुद्ध वेतन सकल वेतन से कम या उसके बराबर होना चाहिए',
            confirmMobileValidation: 'प्राथमिक और द्वितीयक मोबाइल नंबर समान नहीं हो सकते हैं',
            nameValidation: 'नाम एक जैसे नहीं हो सकते',
            midNameValidation: 'नाम एक जैसे नहीं हो सकते',
            dateValidation: 'टू डेट , फ्रॉम डेट से बड़ा होना चाहिए',
            toDateValidation: 'फ्रॉम डेट , टु डेट से बड़ा नहीं होना चाहिए ',
            aadharValidation: 'आधार एक जैसा नहीं हो सकता',
            itrIncomeValidation: 'आयटीआर आय वार्षिक आय से कम या उसके बराबर होनी चाहिए',
            downpaymentMaxValidation: 'डाउन पेमेंट अधिकतम अनुमत मान से अधिक हो गया है',
            downpaymentMinValidation: 'डाउन पेमेंट मूल्य न्यूनतम मूल्य से कम है',
            tenDigitPhoneValidation: 'कृपया १० कों का फ़ोन नंबर दर्ज करें।',
            thirtyCharExceedNameValidation: 'नाम ३० वर्णों से अधिक नहीं होना चाहिए।',
            sixtyCharExceedNameValidation: 'नाम ६० वर्णों से अधिक नहीं होना चाहिए।',
            twentyCharExceedLastNameValidation: 'अंतिम नाम २० वर्णों से अधिक नहीं होना चाहिए।',
            tweleveDigitAdharValidation: 'कृपया १२ अंकों का आधार नंबर दर्ज करें',
            fortyCharExceedAddressValidation: 'पता ४० वर्णों से अधिक नहीं होना चाहिए।',
            fiftyCharExceedAreaValidation: 'क्षेत्र ५० वर्णों से अधिक नहीं होना चाहिए।',
            twentyFiveCharExceedCityValidation: 'शहर २५ वर्णों से अधिक नहीं होना चाहिए।',
            sixDigitPinCodeValidation: 'कृपया ६ अंकों का पिनकोड दर्ज करें।',
            tenDigitPANValidation: 'कृपया १० अंकों का पैन दर्ज करें।',
            fifteenDigitNumericWithTwoDecimalValidation: 'कृपया अधिकतम २ दशमलव मानों के साथ १५ अंकों का अंक दर्ज करें',
            notInRangeFinProduct: 'वित्तीय उत्पाद/विशेष कार्यक्रम द्वारा अनुमत सीमा में नहीं',
            maxCharExceedValidation: 'फ़ील्ड वर्णों की अधिकतम संख्या को पार कर गई है।',
            maxValueExceedValidation: 'फ़ील्ड अधिकतम मान को पार कर गया है.',
            minIncome26000: 'न्यूनतम आय रु. २०,०००',
            minIncome312000: 'न्यूनतम आय रु. ३,१२,०००',
            minValueValidation: 'फ़ील्ड न्यूनतम मान से कम है',
            validPhoneValidation: 'कृपया एक वैध फ़ोन नंबर डालें',
            validNameValidation: 'कृपया मान्य नाम दर्ज करें',
            validNumericAdharValidation: 'कृपया मान्य अंकीय आधार दर्ज करें',
            validEmailValidation: 'कृपया मान्य ईमेल आईडी दर्ज करें',
            validPANValidation: 'कृपया मान्य पैन दर्ज करें',
            validDesignationValidation: 'कृपया मान्य पदनाम दर्ज करें',
            validPincodeValidation: 'कृपया मान्य पिनकोड दर्ज करें',
            validAmountValidation: 'कृपया मान्य राशि दर्ज करें',
            numericValidation: 'कृपया संख्यात्मक मान दर्ज करें',
            noSpecialCharValidation: 'कोई खास अक्षर की अनुमति नहीं है',
            validVariantValidation: 'कृपया वैध वैरिएंट दर्ज करें',
            patternMismatchValidation: 'पैटर्न बेमेल।',
            tenDigitValidPhoneValidation: 'कृपया १० अंकों का फ़ोन नंबर दर्ज करें',
            min6CharValidation: 'कृपया कम से कम ६ वर्ण दर्ज करें',
            tewelveDigitAdharValidation: 'कृपया १२ अंकों का आधार नंबर दर्ज करें',
            min2CharValidation: 'कृपया कम से कम २ अक्षर दर्ज करें',
            min4CharValidation: 'कृपया कम से कम ४ वर्ण दर्ज करें',
            min10CharValidation: 'कृपया कम से कम १० वर्ण दर्ज करें',
            minCharValidation: 'कृपया वर्णों की न्यूनतम संख्या दर्ज करें।',
        }

    }
}